module.exports = __webpack_public_path__ + "d09ccfdd90adbe16cdb3801829d44e16.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_star_gray_2x.png
// module id = 18
// module chunks = 0 1 2 3 4